import { reporticons, toolIcons } from "../Assets/images/image";
import MerchantTransaction from "../Components/Reports/MerchantTransaction";
import LivePayinReport from "../Components/Reports/LivePayinReport";
import Chargeback from "../Components/Reports/Chargeback";
import Withdraw from "../Components/Reports/Withdraw";
import Payout from "../Components/Reports/Payout";
import Reconciliation from "../Components/Reports/Reconciliation";
import WalletBalance from "../Components/Reports/WalletBalance";
import Settlement from "../Components/Reports/Settlement";
import CreditBalance from "../Components/Reports/CreditBalance";
import Vendors from "../Components/Reports/Vendors";
import EKyc from "../Components/Reports/EKyc";
import DownloadCSV from "../Components/Reports/DownloadCSV";
import Guarantee from "../Components/Reports/Guarantee";
import ViewUTR from "../Components/Reports/ViewUTR";
import TransactionsReports from "../Components/Reports/TransactionsReports";

export const ReportsRegistry = [
  {
    label: "Payin",
    key: "Payin",
    requiredSub: "Live Cumulative",
    component: LivePayinReport,
    icon: reporticons.Payin,
  },
  {
    label: "Chargeback",
    key: "Chargeback",
    requiredSub: "Live Cumulative",
    component: Chargeback,
    icon: reporticons.ChargeBack,
  },
  {
    label: "Withdraw",
    key: "Withdraw",
    requiredSub: "Live Cumulative",
    component: Withdraw,
    icon: reporticons.Withdraw,
  },
  {
    label: "Payout",
    key: "Payout",
    requiredSub: "Live Cumulative",
    component: Payout,
    icon: reporticons.Payout,
  },
  {
    label: "Reconciliation",
    key: "Reconciliation",
    requiredSub: "Live Cumulative",
    component: Reconciliation,
    icon: toolIcons.reconciliationTools,
  },
  {
    label: "Wallet Balance",
    key: "Wallet",
    requiredSub: "Live Cumulative",
    component: WalletBalance,
    icon: toolIcons.Wallet,
  },
  {
    label: "Settlement",
    key: "Settlement",
    requiredSub: "Live Cumulative",
    component: Settlement,
    icon: reporticons.Settlement,
  },
  {
    label: "Vendors",
    key: "Vendors",
    requiredSub: "Live Cumulative",
    component: Vendors,
    icon: toolIcons.RegisterVendor,
  },
  {
    label: "Release",
    key: "Release",
    requiredSub: "Live Cumulative",
    component: EKyc,
    icon: reporticons.Ekyc,
  },
  {
    label: "Credit Balance",
    key: "CreditBalance",
    requiredSub: "Live Cumulative",
    component: CreditBalance,
    icon: reporticons.CreditBalance,
  },
  {
    label: "Archived Reports",
    key: "Archived",
    requiredSub: "Live Cumulative",
    component: DownloadCSV,
    icon: reporticons.Archived,
  },
  {
    label: "Guarantee",
    key: "Guarantee",
    requiredSub: "Live Cumulative",
    component: Guarantee,
    icon: reporticons.Guarantee,
  },
  {
    label: "Merchant Transaction",
    key: "MerchantTransaction",
    requiredSub: "Merchant Transaction",
    icon: reporticons.MerchantTransaction,
    component: MerchantTransaction,
  },
  {
    label: "Transactions Reports",
    key: "TransactionsReports",
    requiredSub: "Live Cumulative",
    component: TransactionsReports,
    icon: reporticons.Archived,
  },
  {
    label: "View UTR",
    key: "ViewUTR",
    requiredSub: "Live Cumulative",
    component: ViewUTR,
    icon: reporticons.ViewUTR,
  },
];
